import Plugin from '../core/Plugin';
import TencentInject from './lag/TencentInject';
import { PlayerEvent } from '../PlayerEvents';
import log from 'loglevel';

const LAG_CHECK_INTERVAL_MS = 500;

/**
 * 卡顿监测插件
 * 卡顿事件将由【Switcher自动切线模块】监听和使用
 *
 * @export
 * @class Lag
 * @extends {Plugin}
 */
export default class Lag extends Plugin {
  constructor() {
    super();
    this._readyStateChecking = false;
    this._readyStateInterval = 0;
    this._lastLagTime = 0;
    this._tlag = null;
  }

  init(opts = {}) {
    super.init(opts);
    this._allConfig = opts;
    this._handleCareEvent();
    this._tlag = new TencentInject();
  }

  destroy() {
    super.destroy();

    this._readyStateChecking = false;
    this._lastLagTime = 0;
    clearInterval(this._readyStateInterval);
    if (this._tlag) {
      this._tlag.destroy();
      this._tlag = null;
    }
  }

  static get type() {
    return 'plugin_lag';
  }

  _handleCareEvent() {
    this.player.on('play', this.__play.bind(this));
    this.player.on('pause', this.__pause.bind(this));
    this.player.on('ended', this.__ended.bind(this));
    this.player.on(PlayerEvent.DEFINITION_CHANGED, this.__definitionChanged.bind(this));
    this.player.on(PlayerEvent.ERROR, this.__error.bind(this));
    this.player.on(PlayerEvent.STALLED, this.__error.bind(this));
  }

  __play(e) {
    log.info("卡顿检测模块，收到play事件，启动卡顿检测")
    this.__startCheckReadyState();
  }

  __pause(e) {
    log.info("卡顿检测模块，收到pause事件，停止卡顿检测")
    if(this.player.getIsLive() && this.player.player.video.ended ) {
      //fix: ios下播放hls直播，当推流闪断时（约3s），播放器触发stalled并触发pause，导致无法触发“卡顿+异常”切线
      log.info("此pause事件判断为内部异常触发，跳过停止卡顿检测")
      return
    }
    this.__stopCheckReadyState();
  }

  __ended(e) {
    log.info("卡顿检测模块，收到ended事件，停止卡顿检测")
    this.__stopCheckReadyState();
  }

  __definitionChanged(e) {
    // 接收到切清晰度后，停止卡顿判断
    log.info("卡顿检测模块，收到definitionchange事件，停止卡顿检测")
    this.__stopCheckReadyState();
  }

  __error(e) {
    // let error = e.target && e.target.error;
    // if (error) {
    //   log.info(`卡顿检测模块，收到error事件: code => ${error.code}; details => ${error.message}`);
    // }
    // 为了方便阅读，分开写判断
    // MSE的HLS情况下，拖动进度条报错不予开启
    // if (e && e.type === 'mediaError' && (e.details === 'bufferStalledError' || e.details === 'bufferNudgeOnStall')) {
    //   log.info('忽略');
    //   return;
    // }
    // safari浏览器播放某些HLS视频时，未播放的情况下也报此错误。故不开启
    // if (e && e.target && e.type === 'stalled') {
    //   log.info('忽略');
    //   return;
    // }
    log.info("卡顿检测模块，收到error事件，启动卡顿检测")
    this.__startCheckReadyState();
  }

  __startCheckReadyState() {
    if (this._readyStateChecking) {
      return;
    }
    // 防止重复启动
    this._readyStateChecking = true;
    clearInterval(this._readyStateInterval);

    // 设置当前时间，切线后可能会获取的当前时间和之前保存的不一致，导致误判卡顿恢复
    // 需要增加延时（小于判断卡顿的延时），不然获取的当前时间还是之前的。。。。
    setTimeout(() => {
      this._tlag.setLastTime(this.player.getCurrentTime());
    }, 300);

    // 每500ms检测一下，卡顿持续时间超过2秒，汇报一次卡顿
    let lagCount = 0;
    this._readyStateInterval = setInterval(() => {
      // currentTime等于0时没必要检测（暂屏蔽，因为“未推流即开始播放”场景下需要卡顿切线）
      // if (this.player.getCurrentTime() === 0) {
      //   return
      // }

      // 判断是否卡顿，并返回已连续卡顿次数。
      // PaaS版本2.2.2，内核版本2.1.6以后，统一用腾讯系（通用）方式探测卡顿
      lagCount = this._tlag.isLag(this.player.getCurrentTime(), lagCount);
      // 卡顿，并且每卡顿2s（500ms * 4）
      if (lagCount !== 0 && !(lagCount % (this._allConfig.lagThreshold))) {
        // 记录第一次卡顿时间
        if (this._lastLagTime === 0) {
          // 已卡顿2s才记录时间，所以第一次卡顿时间要向前推2s
          this._lastLagTime = Date.now() - this._allConfig.lagThreshold * LAG_CHECK_INTERVAL_MS;
        }
        this.player.emit2All('lagreport');
      } else if (lagCount === 0 && this._lastLagTime !== 0) {
        // 卡顿恢复（不卡顿，并且有记录卡顿时间）
        // 统计卡顿时长
        let elapsed = Date.now() - this._lastLagTime;
        // 清零上次卡顿时间
        this._lastLagTime = 0;
        this.player.emit2All('lagrecover', elapsed);
      }
    }, LAG_CHECK_INTERVAL_MS);
  }

  __stopCheckReadyState() {
    this._readyStateChecking = false;
    clearInterval(this._readyStateInterval);
  }
}
